export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Certified Technicians',
      description: 'Our experienced team is fully certified and trained in the latest auto body repair techniques'
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Turnaround',
      description: 'We understand you need your vehicle back quickly. Most repairs completed within 3-5 days'
    },
    {
      icon: 'ri-tools-line',
      title: 'Quality Parts Used',
      description: 'We use only OEM and high-quality aftermarket parts to ensure lasting repairs'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Transparent Pricing',
      description: 'Fair, upfront pricing with no hidden fees. Free estimates on all repair work'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Insurance Assistance',
      description: 'We work directly with all major insurance companies to streamline your claim process'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Trusted Service',
      description: 'Family-owned and operated in Gardena for over 15 years with thousands of satisfied customers'
    }
  ];

  return (
    <section id="why-choose-us" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-4">
            <i className="ri-star-line text-amber-600"></i>
            <span className="text-sm text-amber-900 font-semibold">Why Choose Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-4">
            Your Trusted Auto Body Experts
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience the difference of working with certified professionals who care about quality and customer satisfaction
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group p-8 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-amber-200"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Space_Grotesk']">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
